import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import { GOTHAM_BOOK, PT_SERIF } from '../../styles/typography'

/*Styled Components*/
const labelFocus = `
   transform: translate3d(0,-24px,0) scale(0.7);
`
const StyledInputGroup = styled.div`
  width: 100%;
`
const StyledInputWrapper = styled.div`
  position: relative;
  line-height: 56px;
`
export const StyledLabel = styled.label`
  position: absolute;
  z-index: 0;
  color: #ccc;
  cursor: text;
  font-family: ${PT_SERIF};
  font-size: 24px;
  left: 0px;
  pointer-events: none;
  transform-origin: 0;
  transition: transform 0.2s ease-in-out;
  ${props =>
    (props.isFocused || props.hasvalue) &&
    css`
      ${labelFocus};
    `};
`

const StyledErrorMsg = styled.p`
  font-family: ${GOTHAM_BOOK};
  color: #f00;
  margin-bottom: 8px;
`

class InputGroup extends Component {
  state = {
    isFocused: false,
  }
  onFocus = () => {
    return this.setState({ isFocused: true })
  }
  onBlur = e => {
    const { handleBlur } = this.props
    if (handleBlur) {
      handleBlur(e)
    }
    return this.setState({ isFocused: false })
  }

  render() {
    const { label, value, error, children, className } = this.props
    const { isFocused } = this.state
    return (
      <StyledInputGroup className={className}>
        <StyledInputWrapper>
          <StyledLabel isFocused={isFocused} hasvalue={Boolean(value)}>
            {label}
          </StyledLabel>
          {React.cloneElement(children, {
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            error: error,
            value,
          })}
        </StyledInputWrapper>
        {error && <StyledErrorMsg>{error}</StyledErrorMsg>}
      </StyledInputGroup>
    )
  }
}

InputGroup.defaultProps = {
  type: 'text',
}

InputGroup.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  value: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  handleBlur: PropTypes.func,
}

export default InputGroup
